import React from 'react';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import Label from "@/src/components/ui/label/Label";
import { useInView } from 'react-intersection-observer';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';
import styles from './FeaturesSection.module.scss';

type Props = {};

const cart = ['Cart notes', 'In-store pickups', 'Quick buy', 'Slide-out cart', 'Sticky cart'];

const conversion = [
  'Age verifier',
  'Blogs',
  'FAQ Section',
  'Cross-selling',
  'Customizable contact form',
  'EU translations (EN, FR, IT, DE, ES)',
  'Promo banners',
  'In-menu promos',
  'Product badges',
  'Product reviews',
  'Recommended products',
  'Promo popups',
  'Promo tiles',
  'Quick view',
  'Stock counter',
];

const FeaturesSection = (props: Props) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: `-250px 0px 0px`,
    threshold: 0,
  });
  const heading = 'Performance, Upgraded';
  const excerpt =
    'A feature-rich theme designed to make your store faster, smoother, and more effective for every shopper.';

  return (
    <section ref={ref} className={styles.features__section}>
      <Wrapper>
        <Label>selling features</Label>
        <h2 className={`heading__2 ${styles.heading} ${inView && styles.animate__heading}`}>
          {createAnimationArr(heading, styles.word__wrapper, 0, 0.01)}
        </h2>
        <p className={`excerpt ${styles.excerpt} ${inView && styles.animate__excerpt}`}>
          {createAnimationArr(excerpt, styles.word__wrapper, 0.1, 0.01)}
        </p>

        <div className={styles.features__table}>
          <div className={styles.table__row}>
            <p className={styles.row__name}>This Theme is Great for</p>
            <div className={styles.row__info}>
              <div className={styles.row__ceil}>
                <p className={styles.ceil__name}>High-volume stores</p>
                <p className={styles.ceil__descr}>
                  Designed for stores that process a large number of transactions in a given period.
                </p>
              </div>
              <div className={styles.row__ceil}>
                <p className={styles.ceil__name}>Physical stores</p>
                <p className={styles.ceil__descr}>Designed for stores that do in-person selling.</p>
              </div>
              <div className={styles.row__ceil}>
                <p className={styles.ceil__name}>Visual storytelling</p>
                <p className={styles.ceil__descr}>
                  Designed to showcase images to support visual brand storytelling.
                </p>
              </div>
            </div>
          </div>
          <div className={styles.table__row}>
            <p className={styles.row__name}>Cart and Checkout</p>
            <ul className={styles.row__info}>
              {cart && cart.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </div>
          <div className={styles.table__row}>
            <p className={styles.row__name}>Marketing and Conversion</p>
            <ul className={styles.row__info}>
              {conversion && conversion.map((item) => <li key={item}>{item}</li>)}
            </ul>
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default FeaturesSection;
